//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import EmptyCell from "../../components/emptyCell";

export default {
    name: "noticeList",
    components: {EmptyCell},
    props: {
        memberId: {
            type: Number,
            required: true
        },
        status: {
            type: Number,
            required: true
        },

    },
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
        }
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getGoods();
        },
        onLoad() {
            this.pageIndex++;
            this.getGoods()
        },
        getGoods() {
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var page = {
                status: this.status,
                memberId: this.memberId,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/SystemMessage/SearchMyMessages', page).then((res) => {
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                if (this.status == 0) {
                    this.sendUnreadMsg(res.data.result.totalCount);
                } else {
                    this.sendReadMsg(res.data.result.totalCount);
                }

                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }).then(() => {
                this.refreshing = false;
                this.loading = false;
            }).catch((error) => {
                this.refreshing = false;
                this.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },
        sendUnreadMsg(val) {
            //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
            this.$emit('func', val)
        },
        sendReadMsg(val) {
            this.$emit('read', val)
        },
        showDetail(item) {
            this.updateStatus(item.id);
            if (item.businessType === 2) {

                this.$router.push({
                    name: 'welfareNotice'
                })
            } else if (item.businessType === 1 || item.businessType === 5) {
                // this.$router.push({name: 'order'})
                this.$router.push(
                    {
                        name: 'deliverOrder',
                        params: {id: item.businessId}
                    })

            } else if (item.businessType === 3) {
                this.$router.push({
                    name: 'workSheetDetail',
                    params: {
                        id: item.businessId
                    }
                })
            } else if (item.businessType === 6 || item.businessType === 7 || item.businessType === 8 || item.businessType === 9) {
                //新工单
                this.$router.push({
                    name: 'workSheetDetail',
                    params: {
                        id: item.businessId
                    }
                })
            }

        },
        updateStatus(id) {
            abp.ajax.put('/api/services/app/SystemMessage/UpdateStatus?id=' + id).then((res) => {

            })
        },
        // getMyMember() {
        //     const vm = this;
        //     this.$store.dispatch({
        //         type: 'member/getMyMember'
        //     }).then(() => {
        //         vm.member = vm.$store.state.member.memberInfo;
        //         vm.memberId = vm.member.id;
        //         vm.onRefresh();
        //     }).finally(() => {
        //         vm.$toast.clear();
        //     });
        // }

    },
    created() {
        // this.loading = true;
        // this.onRefresh();
    },
    watch: {
        memberId() {
            this.onRefresh();
        }
    }
}
